export interface Annotation {
  year: number;
  label: string;
}

export const annotations: Annotation[] = [
  { year: 1979, label: 'Vrchol' },
  { year: 1989, label: 'Nežná revolúcia' },
  { year: 2004, label: 'Vstup do EÚ' },
  { year: 2020, label: 'COVID-19' }
];
